import React, { memo, MouseEvent } from "react";



import { useAccount, useLayerPopupContext, useSchedule } from "@shared/contexts";



import { PopupKind } from "../../../../@shared/types/layerPopup";


function FreeStreamFooter(
  isAnonymous: boolean,
  open: (active: PopupKind | undefined, isNotDimmed?: boolean) => void,
) {
  return (
    <ul className="linkB">
      <li className="ty01">
        <a
          href="#!"
          title="신규회원가입 혜택"
          onClick={(e: MouseEvent) => {
            e.preventDefault()
            window.open(
              "http://www.wownet.co.kr/Welcome/Welcome/Introduce/Benefits",
            )
          }}
        >
          신규회원
          <br />
          가입혜택
        </a>
      </li>
      <li className="ty02">
        <a
          href="#!"
          title="가입 문의신청"
          onClick={(e: MouseEvent) => {
            e.preventDefault()

            if (isAnonymous) return open("ANONYMOUS")

            open("SIGN_UP")
          }}
        >
          고객센터
          <br />
          가입문의
        </a>
      </li>
    </ul>
  )
}

function PaidStreamFooter(
  isAnonymous: boolean,
  open: (active: PopupKind | undefined, isNotDimmed?: boolean) => void,
) {
  return (
    <ul className="linkB">
      {/* 추후 자유게시판이 생기면 width: 132px 삭제 */}
      <li className="ty01" >
        <a
          href="#!"
          title="신규회원가입 혜택"
          onClick={(e: MouseEvent) => {
            e.preventDefault()
            window.open(
              "http://www.wownet.co.kr/Welcome/Welcome/Introduce/Benefits",
            )
          }}
        >
          신규회원
          <br />
          가입혜택
        </a>
      </li>
      <li className="ty02">
        <a
          href="#!"
          title="가입문의"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            paddingTop: "0",
          }}
          onClick={(e: MouseEvent) => {
            e.preventDefault()

            if (isAnonymous) return open("ANONYMOUS")

            open("SIGN_UP")
          }}
        >
          고객센터
          <br/>
          가입문의
        </a>
      </li>
    </ul>
  )
}

function Footer() {
  const { account } = useAccount()
  const { open } = useLayerPopupContext()
  const { schedule } = useSchedule()
  const isPaidAndPaidUser = schedule?.paymentInformation === "PAID" && account.viewer?.role === "PAID_USER"


  const isAnonymous = account?.viewer?.role === "ANONYMOUS"
  
  if (isPaidAndPaidUser) return PaidStreamFooter(isAnonymous, open)

  return FreeStreamFooter(isAnonymous, open)
}

export default memo(Footer)
